import { TableCell, TableRow, Typography } from '@mui/material';
import { Order } from '../../../../interfaces/Order/Order';
import { TableColumn } from '../../../../components/DataTable/TableColumn';
import { OrderProduct } from '../../../../interfaces/Order/OrderProduct';
import { TextColumn } from '../../../../components/DataTable/TextColumn';
import { PriceColumn } from '../../../../components/DataTable/PriceColumn';
import { DataTable } from '../../../../components/DataTable/DataTable';
import { sharedColors } from '../../../../utils/Style';

type AdditionalRowProps = {
  label: string;
  value: string;
};

const AdditionalRow = ({ label, value }: AdditionalRowProps) => {
  return (
    <TableRow sx={{ backgroundColor: sharedColors.white }}>
      <TableCell colSpan={2}>
        <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
      </TableCell>

      <TableCell>{value}</TableCell>
    </TableRow>
  );
};

const columns: TableColumn<OrderProduct>[] = [
  {
    id: 'name',
    name: 'Ürün',
    accessor: (row) => (
      <TextColumn
        value={row.name}
        secondary={row.options
          .map((option) => option.optionValueName)
          .join(' / ')}
      />
    ),
  },
  {
    id: 'qty',
    name: 'Adet',
    accessor: (row) => <TextColumn value={row.qty.toString()} />,
  },
  {
    id: 'price',
    name: 'Fiyat',
    accessor: (row) => <PriceColumn value={row.lineTotal.raw} />,
  },
];

type OrderBreakdownTableProps = {
  order: Order;
};

export const OrderBreakdownTable = ({ order }: OrderBreakdownTableProps) => {
  const additionalRows = [
    order.discount.raw ? (
      <AdditionalRow label='İndirim' value={`${order.discount.formatted}`} />
    ) : null,
    <AdditionalRow
      label={order.shippingMethod}
      value={order.shippingCost.formatted}
    />,
    order.pointUsage ? (
      <AdditionalRow
        label='Puan Kullanımı'
        value={`${order.pointUsage} Puan`}
      />
    ) : null,
    order.installment ? (
      <AdditionalRow label='Taksit' value={order.installment.toString()} />
    ) : null,
    <AdditionalRow label='Toplam' value={order.total.formatted} />,
  ];

  return (
    <DataTable
      columns={columns}
      totalCount={order.products.length}
      rows={order.products}
      additionalRows={additionalRows}
      hidePagination
    />
  );
};
